import { render, staticRenderFns } from "./error-content.vue?vue&type=template&id=68690be6&scoped=true&"
import script from "./error-content.vue?vue&type=script&lang=js&"
export * from "./error-content.vue?vue&type=script&lang=js&"
import style0 from "./error-content.vue?vue&type=style&index=0&id=68690be6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68690be6",
  null
  
)

export default component.exports